
















import { Component, Vue, Emit } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  private beforeFocusElement: HTMLElement | null = null

  mounted() {
    this.beforeFocusElement = document.activeElement as HTMLElement
    if (this.$refs.dialog instanceof HTMLElement) {
      this.$refs.dialog.focus()
    }
  }

  handleClose() {
    this.close()
  }
  @Emit()
  close(): HTMLElement | null {
    return this.beforeFocusElement
  }

  handleOk() {
    this.ok()
  }
  @Emit()
  ok(): HTMLElement | null {
    return this.beforeFocusElement
  }
}
